import React from "react";
import { ViewMode } from "@/common/model/SpotRequest";

interface ViewModeSwitcherProps {
  mode: ViewMode;
  onModeChange: (mode: ViewMode) => void;
  ridersCount: number;
  requestsCount: number;
}

const ViewModeSwitcher: React.FC<ViewModeSwitcherProps> = ({
  mode,
  onModeChange,
  ridersCount,
  requestsCount,
}) => {
  return (
    <div className="flex items-center bg-gray-100 rounded-lg p-1">
      {/* Live Riders Tab */}
      <button
        onClick={() => onModeChange("riders")}
        className={`
          flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-all
          ${mode === "riders"
            ? "bg-white text-blue-600 shadow-sm"
            : "text-gray-600 hover:text-gray-900"
          }
        `}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        <span>Live Riders</span>
        <span className={`
          px-1.5 py-0.5 rounded-full text-xs font-semibold
          ${mode === "riders"
            ? "bg-blue-100 text-blue-700"
            : "bg-gray-200 text-gray-600"
          }
        `}>
          {ridersCount}
        </span>
      </button>

      {/* Requests Tab */}
      <button
        onClick={() => onModeChange("requests")}
        className={`
          flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-all
          ${mode === "requests"
            ? "bg-white text-orange-600 shadow-sm"
            : "text-gray-600 hover:text-gray-900"
          }
        `}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
        </svg>
        <span>Requests</span>
        {requestsCount > 0 && (
          <span className={`
            px-1.5 py-0.5 rounded-full text-xs font-semibold
            ${mode === "requests"
              ? "bg-orange-100 text-orange-700"
              : "bg-orange-500 text-white animate-pulse"
            }
          `}>
            {requestsCount}
          </span>
        )}
      </button>
    </div>
  );
};

export default ViewModeSwitcher;
